import { isPast, isValid } from 'date-fns'
import { useMemo } from 'react'

import { useApiGetCommonConfig } from 'api/kinerja/kepala-sekolah/common'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import useToggleSdkContext from 'utils/useToogleSdk'

export default function usePenetapanGuard() {
  const toggle = useToggleSdkContext()
  const { isCurrentPeriod, periodYear } = usePeriodContext()

  // Check if penetapan phase is started
  const { data: { data: config } = {}, isLoading: isLoadingConfig } =
    useApiGetCommonConfig(
      {
        // We use the same config as Penetapan Tahunan
        // since one period is equal to one year
        key: 'PENETAPAN_TAHUNAN_TIME_RANGE',
      },
      {
        useErrorBoundary: false,
        staleTime: 60 * 60 * 1000, // 1 hour
      }
    )
  const penetapanStartDateConfig = config?.startDate
  const penetapanStartDate = new Date(
    periodYear,
    penetapanStartDateConfig?.month - 1,
    penetapanStartDateConfig?.day
  )
  const isStarted =
    !isLoadingConfig && penetapanStartDateConfig && isPast(penetapanStartDate)

  const isPenetapanEnabled = useMemo(() => {
    const penetapanEnabled =
      toggle?.['kinerja-dinas-penetapan-enabled'] || false
    const isPenetapanCurrentPeriodEnabled =
      toggle?.['kinerja-dinas-penetapan-current-period-enabled'] || false

    // Return `false` if the current period is not enabled
    if (penetapanEnabled && isCurrentPeriod && !isPenetapanCurrentPeriodEnabled)
      return false

    return penetapanEnabled
  }, [isCurrentPeriod, toggle])

  return {
    isEnabled: isPenetapanEnabled,
    isStarted,
    isLoadingConfig,
    startDate: isValid(penetapanStartDate) ? penetapanStartDate : undefined,
  }
}
